import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import type ApiFeaturedItem from 'src/core/models/api/ApiFeaturedItem';

const initialState = {
	selectedItem: null as ApiFeaturedItem | null,
};

export const useFeaturedItemStore = create(
	combine({ ...initialState }, (set) => {
		const reset = () => set({ ...initialState });

		const open = (item: ApiFeaturedItem) => set({ selectedItem: item });

		const close = () => reset();

		return { open, close, reset };
	}),
);
